import ErrorOutlineOutlined from "@mui/icons-material/ErrorOutlineOutlined";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { useState } from "react";
import { AdditionalServicesCarousel } from "../../modules/additional-services/additional-services-carousel";
import { CreateContentCard } from "../../modules/create-content-card/create-content-card";
import { Page } from "../../modules/layout/components/page";
import { PageContent } from "../../modules/layout/components/page-content";
import {
  SupabaseMomentsRecentlyEditedService,
  SupabaseMomentsSentService,
  SupabaseMomentsUpcomingService,
} from "../../modules/moment/server/supabase-moment-service";
import { useMultiformat } from "../../modules/multiformat/hooks/use-multi-format";
import { useSupabase } from "../../server/supabase/hooks";
import { MomentCarousels } from "../moments/dashboard/moment-carousels";
import { useCustomTemplates } from "./use-custom-templates";

import type { MomentCardMomentActivity } from "../../modules/moment/server/supabase-moment-service";
import type { FC } from "react";

const CreateContentPage: FC = () => {
  const { data: multiformat, error: multiformatError } = useMultiformat();
  useCustomTemplates(multiformat);
  const [recentlyEdited, setRecentlyEdited] = useState<MomentCardMomentActivity[]>();
  const [sent, setSent] = useState<MomentCardMomentActivity[]>();
  const [upcoming, setUpcoming] = useState<MomentCardMomentActivity[]>();

  const limit = 24;

  useSupabase(async ({ supabase, account_id }) => {
    const { data, error } = await new SupabaseMomentsRecentlyEditedService(supabase).getAllMoments(
      account_id,
      {
        limit,
        order: [{ column: "attime", dir: "desc" }],
      },
    );
    if (!error) {
      setRecentlyEdited(data);
    }
  }, []);

  useSupabase(async ({ supabase, account_id }) => {
    const { data, error } = await new SupabaseMomentsSentService(supabase).getAllMoments(
      account_id,
      {
        limit,
        order: [{ column: "attime", dir: "desc" }],
      },
    );
    if (!error) {
      setSent(data);
    }
  }, []);

  useSupabase(async ({ supabase, account_id }) => {
    const { data, error } = await new SupabaseMomentsUpcomingService(supabase).getAllMoments(
      account_id,
      {
        limit,
        order: [{ column: "attime", dir: "asc" }],
      },
    );
    if (!error) {
      setUpcoming(data);
    }
  }, []);

  return (
    <Page title="Home | ChangeEngine">
      {multiformatError ? <MultiformatLoadingError /> : <CreateContentCard />}
      <AdditionalServicesCarousel newPage />
      <PageContent>
        <MomentCarousels recentlyEdited={recentlyEdited} sent={sent} upcoming={upcoming} />
      </PageContent>
    </Page>
  );
};

const MultiformatLoadingError: FC = () => (
  <Card>
    <CardContent>
      <Box display="flex" gap={2} alignItems="center" p={2}>
        <ErrorOutlineOutlined />
        <Typography>
          There was a problem trying to load our AI content generator. Please refresh your browser
          to try again, or use one of the options below.
        </Typography>
      </Box>
    </CardContent>
  </Card>
);

export default CreateContentPage;
